import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import CustomersSection from "../components/CustomersSection";
import OurStory from "../components/OurStory";
import WhyChooseUs from "../components/WhyChooseUs";

export default function Home() {
  return (
    <>
     <div className="relative -mt-[105px]">
      <Hero />
      <Services />
      <About />
      {/* <Testimonials /> */}
      <CustomersSection />
      <OurStory />
      <WhyChooseUs />
      </div>
    </>
  );
}
